import { MouseEvent, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import TertiaryButton from '@components/buttons/TertiaryButton';
import styles from '@components/trackers/Tracker.module.css';
import BodyCopy from '@components/typography/BodyCopy';
import Heading2 from '@components/typography/Heading2';
import { Opener } from '@hooks/useOpener';
import { TrackerStatusEnum } from '@typing/Generated';

type Props = {
  canDownload: boolean;
  children: ReactNode;
  handleDownload?: (e: MouseEvent<HTMLIonButtonElement>) => void;
  kind: 'legal' | 'provider' | 'medical';
  opener: Opener;
  trackerStatus: TrackerStatusEnum;
};

const Tracker = ({ canDownload, children, handleDownload, kind, opener, trackerStatus }: Props) => (
  <div>
    <Heading2>
      <FormattedMessage id={`pages.tracker.${kind}.title`} />
    </Heading2>
    <div className={styles.trackerContent}>
      {handleDownload && (
        <TertiaryButton
          disabled={!canDownload}
          icon="download"
          iconPosition="end"
          onClick={handleDownload}
          textKey={`pages.tracker.${kind}.download`}
        />
      )}
    </div>
    {trackerStatus !== TrackerStatusEnum.COMPLETED ? (
      <div className={styles.trackerAddContainer}>
        <div className={styles.trackerDescription}>
          <BodyCopy>
            <FormattedMessage id={`pages.tracker.${kind}.description`} />
          </BodyCopy>
        </div>
        <div>
          <TertiaryButton
            icon="add"
            iconPosition="end"
            onClick={opener.open}
            textKey={
              trackerStatus === TrackerStatusEnum.NOT_STARTED
                ? `pages.tracker.${kind}.track`
                : `pages.tracker.${kind}.addContinue`
            }
          />
        </div>
      </div>
    ) : (
      <div>
        {children}
        {kind !== 'legal' && (
          <div className={styles.trackerAdd}>
            <TertiaryButton icon="add" iconPosition="end" onClick={opener.open} textKey={`pages.tracker.${kind}.add`} />
          </div>
        )}
      </div>
    )}
  </div>
);

export default Tracker;
